import c from 'util/const';

export const canManageOrganization = roles =>
  Array.isArray(roles) &&
  (roles.includes(c.roles.TENANT_ADMIN) ||
    roles.includes(c.roles.SYSTEM_ADMIN));

export const isOrganizationViewer = roles =>
  Array.isArray(roles) &&
  roles.includes(c.roles.VIEWER) &&
  !canManageOrganization(roles);

export const resolveUserRoles = detail => {
  const role = String(detail?.TokenRole || '')
    .replace(/[_\s]/g, '')
    .toLowerCase();
  if (detail?.IsAdmin === true || detail?.User?.IsAdmin === true)
    return [c.roles.SYSTEM_ADMIN];
  if (detail?.User?.IsTenantAdmin === true || role === 'tenantadmin')
    return [c.roles.TENANT_ADMIN];
  if (detail?.IsOrgUser === true && role === 'viewer') return [c.roles.VIEWER];
  return role === 'systemadmin' ? [c.roles.SYSTEM_ADMIN] : [];
};

export const canViewOrganization = roles =>
  canManageOrganization(roles) || isOrganizationViewer(roles);

export const canAccessOrganizationPath = (roles, pathname) => {
  if (canManageOrganization(roles)) return true;
  if (!isOrganizationViewer(roles))
    return (
      !pathname.startsWith('/admin') &&
      !pathname.startsWith('/organization/billing')
    );
  return (
    [
      '/',
      '/admin',
      '/admin/location',
      '/admin/connection-requests',
      '/admin/notaries',
      '/admin/entries',
      '/account/notifications',
      '/account/user-profile'
    ].includes(pathname) || /^\/admin\/notaries\/[^/]+\/entries$/.test(pathname)
  );
};
